
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const PractitionersLoading: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-24">
        <div className="bg-gradient-to-br from-amber-50 to-orange-50">
          <div className="container mx-auto px-4 py-8">
            <div className="text-center mb-8">
              <div className="h-12 bg-gray-200 rounded animate-pulse mb-4 max-w-md mx-auto"></div>
              <div className="h-6 bg-gray-200 rounded animate-pulse max-w-2xl mx-auto"></div>
            </div>
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="hidden lg:block w-80 flex-shrink-0">
                <div className="h-96 bg-gray-200 rounded animate-pulse"></div>
              </div>
              <div className="flex-1">
                <div className="space-y-6">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="h-48 bg-gray-200 rounded animate-pulse"></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PractitionersLoading;
